import api from '../api'

export function deletePartner(partnerId: string): Promise<void> {
    return api.del({ path: `/partners/${partnerId}` })
}
